import { useEffect } from 'react';

interface AdPlacementProps {
  id: number;
}

/**
 * AdPlacement component for Ezoic ads
 * 
 * @param {number} id - The unique 3-digit ID for the ad placement
 * @returns A div with the Ezoic ad placeholder
 */
const AdPlacement = ({ id }: AdPlacementProps) => {
  useEffect(() => {
    // Ensure the ezstandalone object exists
    if (window.ezstandalone && window.ezstandalone.cmd) {
      // Push the command to show the ad
      window.ezstandalone.cmd.push(function() {
        window.ezstandalone.showAds(id);
      });
    }
  }, [id]);

  return (
    <div className="ad-container my-4">
      <div id={`ezoic-pub-ad-placeholder-${id}`}></div>
    </div>
  );
};

export default AdPlacement;